import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function RequireAdmin({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // Still resolving the session — render nothing briefly to avoid a flash redirect.
  if (user === undefined) {
    return (
      <div className="max-w-md mx-auto px-6 py-20 font-mono-plex text-xs uppercase tracking-wider text-[#555]">
        Verifying session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
